import { CoreWarning } from '@goodt-wcore/errors';
import { fail, success } from '@goodt-common/utils';

// vue-devtools try to inspect this keys and accidentally produce senseless `CoreWarnings`
const ExcludedVarNames = ['_isVue', 'state', 'render', 'currentRoute'];

/**
 *
 * @param {string[]} stateVars
 * @param {string[]} descriptorVars
 * @param {string[]} varAliases
 * @param {function} [traceContext]
 *
 * @return {SafeResult<null, CoreWarning[]>}
 */
export const validateWidgetVars = (
    { stateVars, descriptorVars, varAliases },
    { traceContext = validateWidgetVars } = {}
) => {
    stateVars = stateVars
        .filter((stateVar) => typeof stateVar === 'string')
        .filter((stateVar) => ExcludedVarNames.includes(stateVar) === false);

    const problems = [];

    const varNamesMissed = stateVars.filter((varName) => descriptorVars.includes(varName) === false);
    if (varNamesMissed.length > 0) {
        const warning = new CoreWarning(
            `MISSED descriptor.vars['${varNamesMissed
                .map(String)
                .join(
                    `', '`
                )}']. (Variable should be described in descriptor.vars object to be available for configuration)`
        );
        if (Error.captureStackTrace) {
            Error.captureStackTrace(warning, traceContext);
        }
        problems.push(warning);
    }

    const varNamesNotLinked = stateVars.filter((varName) => varAliases.includes(varName) === false);
    if (varNamesNotLinked.length > 0) {
        const warning = new CoreWarning(
            `NOT ACTIVE props.varAliases['${varNamesNotLinked
                .map(String)
                .join(`', '`)}']. (Variable should be activated by assigning Global Store Var in Variable Panel)`
        );
        if (Error.captureStackTrace) {
            Error.captureStackTrace(warning, traceContext);
        }
        problems.push(warning);
    }

    if (problems.length > 0) {
        return fail(problems);
    }

    return success(true);
};
